(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[903],{

/***/ 40903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ componentTypes_Instagram; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/helpers/misc/withClientSuspense.tsx
var withClientSuspense = __webpack_require__(79229);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./src/hooks/useWidth.ts
var useWidth = __webpack_require__(9177);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Container/index.js
var Container = __webpack_require__(59848);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./src/components/Image/index.tsx
var Image = __webpack_require__(56036);
// EXTERNAL MODULE: ./src/hooks/useComponentWidth.ts + 1 modules
var useComponentWidth = __webpack_require__(47582);
// EXTERNAL MODULE: ./src/hooks/useRef.ts
var useRef = __webpack_require__(53630);
// EXTERNAL MODULE: ./src/components/componentTypes/Instagram/styles.module.css
var styles_module = __webpack_require__(67222);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/componentTypes/Instagram/Content.tsx






function Content(param) {
    var posts = param.posts, cols = param.cols;
    var container = (0,useRef/* default */.Z)();
    var containerWidth = (0,useComponentWidth/* default */.Z)(container);
    var width = containerWidth / cols;
    if (!posts) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).posts,
        ref: container,
        children: posts.map(function(post, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).post,
                style: {
                    width: width,
                    height: width
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: post.permalink,
                    target: "blank",
                    className: (styles_module_default()).link,
                    style: {
                        height: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        objectFit: "cover",
                        width: width,
                        height: width,
                        src: post.mediaType === "VIDEO" ? post.thumbnailUrl : post.mediaUrl,
                        alt: post.caption
                    })
                })
            }, idx);
        })
    });
};

// EXTERNAL MODULE: ./src/components/componentTypes/Instagram/Title/styles.module.css
var Title_styles_module = __webpack_require__(72554);
var Title_styles_module_default = /*#__PURE__*/__webpack_require__.n(Title_styles_module);
;// CONCATENATED MODULE: ./src/components/componentTypes/Instagram/Title/index.tsx



function Title(param) {
    var username = param.username, title = param.title;
    if (!title) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Title_styles_module_default()).title,
            children: [
                title,
                "Siguenos en",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    target: "blank",
                    href: "https://www.instagram.com/".concat(username),
                    children: [
                        "@",
                        username
                    ]
                })
            ]
        });
    }
    var parts = title.split("@");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Title_styles_module_default()).title,
        children: [
            parts[0],
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                target: "blank",
                href: "https://www.instagram.com/".concat(username),
                children: [
                    "@",
                    username
                ]
            }),
            parts[1]
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/componentTypes/Instagram/index.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query ($websiteId: ID, $limit: Float) {\n        website(websiteId: $websiteId) {\n          _id\n          instagramMultimedia(limit: $limit) {\n            data {\n              caption\n              mediaType\n              permalink\n              username\n              thumbnailUrl\n              mediaUrl\n            }\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}












function Instagram(props) {
    var title = props.title, colsMobile = props.colsMobile, rowsMobile = props.rowsMobile;
    var screenWidth = (0,useWidth/* default */.ZP)();
    var ref = screenWidth <= 760 ? {
        cols: colsMobile,
        rows: rowsMobile
    } : props, cols = ref.cols, rows = ref.rows;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var website = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(_templateObject()),
        variables: {
            websiteId: websiteId,
            limit: rows * cols
        }
    }).website;
    var instagramMultimedia = (website || {}).instagramMultimedia;
    var username = get_default()(instagramMultimedia, "data[0].username");
    if (!username) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    username: username,
                    title: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                    cols: cols,
                    posts: instagramMultimedia && instagramMultimedia.data
                })
            ]
        })
    });
}
/* harmony default export */ var componentTypes_Instagram = ((0,withClientSuspense/* default */.Z)(Instagram));


/***/ }),

/***/ 79229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ withClientSuspense; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_ClientSuspense__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88385);
/* harmony import */ var _components_SuspenseLoading_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53762);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function withClientSuspense(Component) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SuspenseLoading_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
    return function WithClientSuspense(props) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ClientSuspense__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            fallback: fallback,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, _objectSpread({}, props))
        });
    };
};


/***/ }),

/***/ 47582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useComponentSize; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useInterval.ts

function useInterval(callback, time) {
    var callbackRef = (0,react.useRef)(callback);
    callbackRef.current = callback;
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            return callbackRef.current();
        }, time);
        return function() {
            clearInterval(interval);
        };
    }, [
        time
    ]);
};

// EXTERNAL MODULE: ./src/hooks/useIsomorphicLayoutEffect.ts
var useIsomorphicLayoutEffect = __webpack_require__(50153);
;// CONCATENATED MODULE: ./src/hooks/useComponentWidth.ts



function getSize(el) {
    if (!el) return;
    return el.offsetWidth;
}
function useComponentSize(ref) {
    var handleResize = function handleResize() {
        if (ref && ref.current) {
            var newWidth = getSize(ref.current);
            if (newWidth !== width) {
                if (width && !newWidth) return;
                setComponentSize(newWidth);
            }
        }
    };
    var _$ref = (0,react.useState)(getSize(ref.current)), width = _$ref[0], setComponentSize = _$ref[1];
    (0,react.useEffect)(function() {
        handleResize();
    });
    (0,useIsomorphicLayoutEffect/* default */.Z)(function() {
        handleResize();
    });
    useInterval(function() {
        if (!width) {
            handleResize();
        }
    }, 100);
    return width || 1;
};


/***/ }),

/***/ 50153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90257);


var useIsomorphicLayoutEffect = (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)() ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
/* harmony default export */ __webpack_exports__["Z"] = (useIsomorphicLayoutEffect);


/***/ }),

/***/ 53630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; },
/* harmony export */   "s": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




/***/ }),

/***/ 9177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ DEFAULT_DESKTOP_WIDTH; },
/* harmony export */   "ZP": function() { return /* binding */ useWidth; }
/* harmony export */ });
/* unused harmony export DEFAULT_MOBILE_WIDTH */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
/* harmony import */ var _providers_MobileOrDesktopContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95078);




var DEFAULT_DESKTOP_WIDTH = 1920;
var DEFAULT_MOBILE_WIDTH = 360;
function useWidth() {
    var ssrMobileOrDesktop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_MobileOrDesktopContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    var ssrWidth = ssrMobileOrDesktop === "mobile" ? DEFAULT_MOBILE_WIDTH : DEFAULT_DESKTOP_WIDTH;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)() ? ssrWidth : window.innerWidth), width = ref[0], setWidth = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = function handler() {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handler);
        return function() {
            window.removeEventListener("resize", handler);
        };
    }, []);
    return width !== null && width !== void 0 ? width : ssrWidth;
};


/***/ }),

/***/ 95078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext("desktop"));


/***/ }),

/***/ 72554:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"_1WPFzAQ4qw_-tzsBfwThNM appSubtitle"};

/***/ }),

/***/ 67222:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ZMnmtBoiE2ESml_6NoPhn","posts":"f1GIlrTgnvqKdrCWI17-m","post":"_3wJQFlNqYU-jLsWIXA3b-_","link":"_3rUf2QvWnyLuFHWoH-Nn8H buttonShadow"};

/***/ })

}]);